var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop } from 'vue-property-decorator';
import { PageService } from '~/utils/page.service';
import { CaseInfoService } from '../../services/domain-service/case-info.service';
var ManualDistrubute = /** @class */ (function (_super) {
    __extends(ManualDistrubute, _super);
    function ManualDistrubute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sum = 0;
        _this.days = 0;
        _this.count = 0;
        _this.caseList = []; // 案件数组
        _this.manualModel = {
            caseIds: '',
            distributeTypeList: ['TEL'],
            partCollectionDays: '',
        };
        _this.submitLoading = false;
        return _this;
    }
    ManualDistrubute.prototype.refreshList = function () {
    };
    ManualDistrubute.prototype.close = function () {
    };
    ManualDistrubute.prototype.reset = function () {
        var form = this.$refs['form'];
        form.resetFields();
    };
    ManualDistrubute.prototype.created = function () {
        this.overdueAmount();
        this.caseCount();
        this.getCollectionDays(this.manualModel.distributeTypeList);
    };
    ManualDistrubute.prototype.getCollectionDays = function (val) {
        var _this = this;
        // 多选时仅当只选中一个案件池才自动带出催收天数
        if (!val || val.length !== 1) {
            return;
        }
        this.CaseInfoService.getCollectionDays(val[0]).subscribe(function (data) {
            if (data) {
                _this.manualModel.partCollectionDays = data;
                _this.days = data;
            }
        });
    };
    ManualDistrubute.prototype.overdueAmount = function () {
        var _this = this;
        var paramDatas = {
            principalId: this.importModel.principalId,
            batchNumber: this.importModel.batchNumber,
            mobileNo: this.importModel.mobileNo,
            personalName: this.importModel.personalName,
            dayRange: this.importModel.dayRange,
            amountRange: this.importModel.amountRange,
            rateRange: this.importModel.rateRange,
            handNumber: this.importModel.handNumber,
            overduePeriod: this.importModel.overduePeriod,
            areadId: this.importModel.areadId,
            labelName: this.importModel.labelName,
            distributeType: this.importModel.distributeType,
            partCollectionDays: this.importModel.partCollectionDays,
            caseNumber: this.importModel.caseNumber,
            principalName: this.importModel.principalName,
            partnerName: this.importModel.partnerName,
            bankName: this.importModel.bankName,
            businessAddress: this.importModel.businessAddress,
            boardAddress: this.importModel.boardAddress,
            carNo: this.importModel.carNo,
            idCard: this.importModel.idCard,
            overdueAmountStart: this.importModel.amountRange ? this.importModel.amountRange.min : '',
            overdueAmountEnd: this.importModel.amountRange ? this.importModel.amountRange.max : '',
            dataFromSource: this.importModel.dataFromSource ? this.importModel.dataFromSource : null,
            loanDateMin: this.$filter.dateRanageFormat(this.importModel.loanDate).start,
            loanDateMax: this.$filter.dateRanageFormat(this.importModel.loanDate).end,
            overdueDays: this.importModel.overdueDays,
            compensationMoney: this.importModel.compensationMoney,
            overdueDaysStart: this.importModel.overdueDays ? this.importModel.overdueDays.min : '',
            overdueDaysEnd: this.importModel.overdueDays ? this.importModel.overdueDays.max : '',
            compensationMoneyMin: this.importModel.compensationMoney ? this.importModel.compensationMoney.min : '',
            compensationMoneyMax: this.importModel.compensationMoney ? this.importModel.compensationMoney.max : '',
        };
        if (this.selectionList.length === 0) {
            this.CaseInfoService.getOverdueAmount(paramDatas).subscribe(function (data) {
                _this.setSum(data);
            });
        }
        else {
            this.sum = this.selectionList
                .map(function (v) { return v.overdueAmount; })
                .reduce(function (a, b) { return a + b; }, 0)
                .toFixed(2);
        }
    };
    ManualDistrubute.prototype.setSum = function (sum) {
        if (this.selectionList.length === 0) {
            this.sum = sum;
            return;
        }
        else {
            this.sum = this.selectionList
                .map(function (v) { return v.overdueAmount; })
                .reduce(function (a, b) { return a + b; }, 0)
                .toFixed(2);
        }
    };
    ManualDistrubute.prototype.caseCount = function () {
        var _this = this;
        var paramDatas = {
            principalId: this.importModel.principalId,
            batchNumber: this.importModel.batchNumber,
            mobileNo: this.importModel.mobileNo,
            personalName: this.importModel.personalName,
            dayRange: this.importModel.dayRange,
            amountRange: this.importModel.amountRange,
            rateRange: this.importModel.rateRange,
            handNumber: this.importModel.handNumber,
            overduePeriod: this.importModel.overduePeriod,
            areadId: this.importModel.areadId,
            labelName: this.importModel.labelName,
            distributeType: this.importModel.distributeType,
            partCollectionDays: this.importModel.partCollectionDays,
            caseNumber: this.importModel.caseNumber,
            principalName: this.importModel.principalName,
            partnerName: this.importModel.partnerName,
            bankName: this.importModel.bankName,
            businessAddress: this.importModel.businessAddress,
            boardAddress: this.importModel.boardAddress,
            carNo: this.importModel.carNo,
            idCard: this.importModel.idCard,
            overdueAmountStart: this.importModel.amountRange ? this.importModel.amountRange.min : '',
            overdueAmountEnd: this.importModel.amountRange ? this.importModel.amountRange.max : '',
            dataFromSource: this.importModel.dataFromSource ? this.importModel.dataFromSource : null,
            loanDateMin: this.$filter.dateRanageFormat(this.importModel.loanDate).start,
            loanDateMax: this.$filter.dateRanageFormat(this.importModel.loanDate).end,
            overdueDays: this.importModel.overdueDays,
            compensationMoney: this.importModel.compensationMoney,
            overdueDaysStart: this.importModel.overdueDays ? this.importModel.overdueDays.min : '',
            overdueDaysEnd: this.importModel.overdueDays ? this.importModel.overdueDays.max : '',
            compensationMoneyMin: this.importModel.compensationMoney ? this.importModel.compensationMoney.min : '',
            compensationMoneyMax: this.importModel.compensationMoney ? this.importModel.compensationMoney.max : '',
        };
        if (this.selectionList.length === 0) {
            this.CaseInfoService.getCaseCount(paramDatas).subscribe(function (data) {
                _this.setCount(data);
            });
        }
        else {
            this.count = this.selectionList.length;
        }
    };
    ManualDistrubute.prototype.setCount = function (count) {
        if (this.selectionList.length === 0) {
            this.count = count;
            return;
        }
        this.count = this.selectionList.length;
    };
    /**
     * 刷新
     */
    ManualDistrubute.prototype.refresh = function (caseList, importModel) {
        this.overdueAmount();
        this.caseCount();
        this.importModel = importModel;
        this.caseList = caseList;
    };
    /**
     * 确定
     */
    ManualDistrubute.prototype.submit = function () {
        var _this = this;
        // if(this.count && this.count > 200){
        //   this.$message.error('分案案件数量不能超过200！');
        //   return;
        // }
        if (!this.manualModel.distributeTypeList || this.manualModel.distributeTypeList.length === 0) {
            this.$message.error('请至少选择一个案件池！');
            return;
        }
        if (!this.manualModel.partCollectionDays) {
            this.$message.error('请输入催收天数！');
            return;
        }
        if (this.days && this.days < this.manualModel.partCollectionDays) {
            this.$message.error('催收天数不能大于' + this.days);
            return;
        }
        if (this.selectionList.length === 0) {
            var paramDatas = {
                principalId: this.importModel.principalId,
                batchNumber: this.importModel.batchNumber,
                mobileNo: this.importModel.mobileNo,
                personalName: this.importModel.personalName,
                dayRange: this.importModel.dayRange,
                amountRange: this.importModel.amountRange,
                rateRange: this.importModel.rateRange,
                handNumber: this.importModel.handNumber,
                overduePeriod: this.importModel.overduePeriod,
                areadId: this.importModel.areadId,
                labelName: this.importModel.labelName,
                distributeTypeList: this.manualModel.distributeTypeList,
                partCollectionDays: this.manualModel.partCollectionDays,
                caseNumber: this.importModel.caseNumber,
                principalName: this.importModel.principalName,
                partnerName: this.importModel.partnerName,
                bankName: this.importModel.bankName,
                businessAddress: this.importModel.businessAddress,
                boardAddress: this.importModel.boardAddress,
                carNo: this.importModel.carNo,
                idCard: this.importModel.idCard,
                overdueAmountStart: this.importModel.amountRange ? this.importModel.amountRange.min : '',
                overdueAmountEnd: this.importModel.amountRange ? this.importModel.amountRange.max : '',
                dataFromSource: this.importModel.dataFromSource ? this.importModel.dataFromSource : null,
                loanDateMin: this.$filter.dateRanageFormat(this.importModel.loanDate).start,
                loanDateMax: this.$filter.dateRanageFormat(this.importModel.loanDate).end,
                overdueDays: this.importModel.overdueDays,
                compensationMoney: this.importModel.compensationMoney,
                overdueDaysStart: this.importModel.overdueDays ? this.importModel.overdueDays.min : '',
                overdueDaysEnd: this.importModel.overdueDays ? this.importModel.overdueDays.max : '',
                compensationMoneyMin: this.importModel.compensationMoney ? this.importModel.compensationMoney.min : '',
                compensationMoneyMax: this.importModel.compensationMoney ? this.importModel.compensationMoney.max : '',
            };
            this.submitLoading = true;
            this.CaseInfoService.distributeCaseInfoByRequest(paramDatas).subscribe(function (data) {
                _this.submitLoading = false;
                _this.$message.success('分配成功');
                _this.refreshList();
                _this.close();
            }, function (_a) {
                var msg = _a.msg;
                _this.submitLoading = false;
            });
        }
        else {
            var caseId = this.selectionList.map(function (v) { return v.id; });
            var paramData = {
                caseIds: caseId,
                distributeTypeList: this.manualModel.distributeTypeList,
                partCollectionDays: this.manualModel.partCollectionDays,
            };
            this.submitLoading = true;
            this.CaseInfoService.distributeCaseInfo(paramData).subscribe(function (data) {
                _this.submitLoading = false;
                _this.$message.success('分配成功');
                _this.refreshList();
                _this.close();
            }, function (_a) {
                var msg = _a.msg;
                _this.submitLoading = false;
            });
        }
    };
    __decorate([
        Prop()
    ], ManualDistrubute.prototype, "selectionList", void 0);
    __decorate([
        Prop({ default: function () { return []; } })
    ], ManualDistrubute.prototype, "visabledPool", void 0);
    __decorate([
        Dependencies(PageService)
    ], ManualDistrubute.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], ManualDistrubute.prototype, "CaseInfoService", void 0);
    __decorate([
        Prop()
    ], ManualDistrubute.prototype, "importModel", void 0);
    __decorate([
        Emit('refreshList')
    ], ManualDistrubute.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], ManualDistrubute.prototype, "close", null);
    ManualDistrubute = __decorate([
        Component({
            components: {},
        })
    ], ManualDistrubute);
    return ManualDistrubute;
}(Vue));
export default ManualDistrubute;
